(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './chain'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./chain'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.chain);
    global.index = mod.exports;
  }
})(this, function (exports, _chain) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.chain = undefined;
  exports.chain = _chain.chain;
});